var _ = require('underscore');

var React = require("react");
const createReactClass = require("create-react-class");

var form = require("../../deploynaut/js/Form.jsx");
var StackPicker = require('./StackPicker.jsx');

var StackCreator = createReactClass({

	getInitialState: function() {

		var self = this;
		var orgOptions = [];
		_.keys(this.props.model.Organisations).forEach(function(id) {
			var org = self.props.model.Organisations[id];
			orgOptions.push({
				id: org.ID.toString(),
				value: org.Title,
				CanCreateTrialStack: org.CanCreateTrialStack,
				CanCreatePaidStack: org.CanCreatePaidStack,
				TrialCode: org.TrialCode,
			});
		});

		var self = this;
		var wafOptions = [];
		_.keys(this.props.model.WAFs).forEach(function(id) {
			var waf = self.props.model.WAFs[id];
			wafOptions.push({
				id: waf.ID,
				value: waf.Title
			});
		});

		var self = this;
		var clusterOptions = [];
		_.keys(this.props.model.Clusters).forEach(function(id) {
			var cluster = self.props.model.Clusters[id];
			clusterOptions.push({
				id: cluster.ID,
				value: cluster.ID ? (cluster.Name + ' (' + cluster.Region + ')') : 'Choose a cluster'
			});
		});

		return {
			securityID: this.props.model.InitialSecurityID,
			orgOptions: orgOptions,
			wafOptions: wafOptions,
			clusterOptions: clusterOptions,
			enabledTypes: [],
			stackSpecs: this.props.model.StackSpecs,
			counter: 0
		};
	},

	onSetOrg: function(value) {
		if (_.isObject(this.props.model.Organisations[value])) {
			var enabledTypes = [];
			var org = this.props.model.Organisations[value];

			// Rebuild the stackSpecs structure to include the new trial spec for the selected organisation.
			var newStackSpecs = this.state.stackSpecs;
			if (org.TrialCode) {
				var trialSpec = {
					'trial': _.clone(this.props.model.StackSpecs[org.TrialCode])
				};
				trialSpec['trial']['Stack size'] += ' (trial)';
				newStackSpecs = _.extend(trialSpec, this.props.model.StackSpecs);

				this.setState({
					stackSpecs: newStackSpecs
				});
			}

			// Work out which stack types can be created for the newly selected organisation.
			_.keys(newStackSpecs).forEach(function(code) {
				if (org.CanCreateTrialStack && code==='trial') {
					enabledTypes.push(code);
				}
				if (org.CanCreatePaidStack && code!=='trial') {
					enabledTypes.push(code);
				}
			});
			this.setState({
				enabledTypes: enabledTypes
			});
		}
	},

	render: function() {

		if (this.props.model.Errors.length>0) {
			return (
				<div className="row">
					<div className="col-md-8 col-md-offset-2">
						<div className="alert alert-danger" dangerouslySetInnerHTML={{__html:this.props.model.Errors.join('<br/>')}}/>
					</div>
				</div>
			);
		}

		var orgField = null;
		if (this.state.orgOptions.length > 0) {
			orgField = (
				<div className="form-group">
					<label htmlFor="OrganisationID">Organisation</label>
					<form.Select name="OrganisationID" required validationError="Please specify organisation"
								 onSetValue={this.onSetOrg}
								 options={this.state.orgOptions} value={this.state.orgOptions[0].id} />
				</div>
			);
		}

		var clusterField = null;
		if (this.state.clusterOptions.length > 0) {
			clusterField = (
				<div className="form-group">
					<label htmlFor="ClusterID">Cluster</label>
					<form.Select name="ClusterID" required validationError="Please specify cluster"
								 options={this.state.clusterOptions} value="" />
				</div>
			);
		}

		var wafField = null;
		if (this.state.wafOptions.length > 1) {
			wafField = (
				<div className="form-group">
					<label htmlFor="WAFType">WAF Type</label>
					<form.Select name="WAFType"
								 required validationError="Select a WAF type"
								 options={this.state.wafOptions}
								 value="None"
								 disabledReason="Not available" />
					<div className="help-text">If you will be using a WAF on your Production environment, select it here. If your choice is unavailable, contact Service Desk for assistance.</div>
				</div>
			);
		}

		return (
			<div className="row">
				<div className="col-md-8">
					<form.Form ref="stackcreateForm"
						url={this.props.model.CreateStackUrl}
						securityID={this.state.securityID}
						buttonTitle="Create stack"
						buttonSubmittingTitle="Creating...">

						<div className="form-group">
							<label htmlFor="Name">Stack name</label>
							<form.Input name="Name" required validationError="Please enter your stack title" />
							<div className="help-text">Limited to alphanumeric characters, underscores and hyphens.</div>
						</div>

						<div className="form-group">
							<label htmlFor="CVSPath">Git URL</label>
							<form.Input name="CVSPath" required validationError="Please enter your git URL" />
							<div className="help-text">Your repository URL so we can clone your code (eg. ssh://git@code.platform.silverstripe.com:222/myteam/site.git)</div>
						</div>

						{orgField}

						<div className="form-group">
							<label htmlFor="StackSize">Stack size</label>
							<StackPicker stackSpecs={this.state.stackSpecs} name="StackSize"
								required validationError="Please choose your stack size"
								enabledTypes={this.state.enabledTypes}
								disabledReason="Not available" />
							<div className="help-text">Choose the size of your Silverstripe Cloud stack.</div>
						</div>

						{wafField}

						{clusterField}

						<div className="form-group">
							<label htmlFor="HasSolr">Create Solr servers for all environments in this stack</label>
							<form.Checkbox name="HasSolr" value={false}/>
						</div>
					</form.Form>
				</div>
			</div>
		);
	}
});

module.exports = StackCreator;
